/*
  AIKO — "Sumá a tu compra" (Mecánica 2).

  Dos operaciones nada más:

   - "Sumar": POST a /cart/add.js pidiendo de paso las secciones del carrito, y se le pasa la
     respuesta al `renderContents()` del <cart-drawer> del tema. Es el mismo camino que usa el
     product-form de Dawn, así que el drawer se repinta como siempre.

   - "Cambiar" (upgrade del Doppler): primero se agrega el combo y DESPUÉS se pone en 0 la variante
     del Doppler. En ese orden: si el agregado falla, el cliente no se queda sin nada.
     El 0 va por /cart/update.js indexado por variante y no por línea, porque el número de línea se
     mueve al agregar, y porque si el Doppler quedó partido en dos líneas (una con la propiedad
     `_medio_pago` y otra sin) hay que limpiar las dos.

  La delegación de eventos va en `document` a propósito: Dawn reemplaza el innerHTML de
  #CartDrawer en cada cambio, así que cualquier listener puesto sobre los botones se perdería.
  Por el mismo motivo este archivo se carga siempre (incluso con el carrito vacío): los <script>
  insertados por innerHTML no se ejecutan, así que tiene que estar en el HTML original.

  La propiedad `_medio_pago` no se setea acá: <aiko-payment-choice> la vuelve a escribir en TODAS
  las líneas del carrito al momento de ir al checkout.
*/
(function () {
  if (window.__aikoCrossSell) return;
  window.__aikoCrossSell = true;

  var BUSY_LABEL = '…';

  function routeFor(name, fallback) {
    var all = window.routes || {};
    return (all[name] || fallback) + '.js';
  }

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionIds() {
    var node = drawer();
    if (!node || typeof node.getSectionsToRender !== 'function') {
      return ['cart-drawer', 'cart-icon-bubble'];
    }
    return node.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error((data && data.description) || (data && data.message) || 'cart');
        return data;
      });
    });
  }

  function withSections(payload) {
    payload.sections = sectionIds();
    payload.sections_url = window.location.pathname;
    return payload;
  }

  function addItem(variantId, quantity, sections) {
    var payload = { items: [{ id: Number(variantId), quantity: quantity }] };
    if (sections) withSections(payload);
    return post(routeFor('cart_add_url', '/cart/add'), payload);
  }

  function zeroVariant(variantId) {
    var updates = {};
    updates[String(variantId)] = 0;
    return post(routeFor('cart_update_url', '/cart/update'), withSections({ updates: updates }));
  }

  function repaint(state) {
    var node = drawer();
    if (!node || !state || !state.sections) {
      window.location.reload();
      return;
    }
    node.renderContents(state);
  }

  function showError(scope, message) {
    var box = scope ? scope.querySelector('[data-aiko-cs-error]') : null;
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function variantFor(button) {
    var item = button.closest('[data-aiko-cs-item]');
    var select = item ? item.querySelector('[data-aiko-cs-variant]') : null;
    if (select && select.value) return select.value;
    return button.getAttribute('data-aiko-cs-variant-id');
  }

  function run(button) {
    if (button.disabled) return;

    var scope = button.closest('[data-aiko-crosssell]');
    var variantId = variantFor(button);
    if (!variantId) return;

    var box = scope ? scope.querySelector('[data-aiko-cs-error]') : null;
    if (box) box.hidden = true;

    var label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = BUSY_LABEL;

    var isUpgrade = button.getAttribute('data-aiko-cs-kind') === 'up';
    var chain;

    if (isUpgrade) {
      var replaceId = button.getAttribute('data-aiko-cs-replace');
      var replaceQty = parseInt(button.getAttribute('data-aiko-cs-replace-qty'), 10) || 1;
      chain = addItem(variantId, replaceQty, false).then(function () {
        return zeroVariant(replaceId);
      });
    } else {
      chain = addItem(variantId, 1, true);
    }

    chain
      .then(repaint)
      .catch(function (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        showError(scope, 'No pudimos agregarlo. Probá de nuevo en un momento.');
        if (window.console && console.warn) console.warn('[aiko-cart-crosssell]', error);
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-aiko-cs-add]');
    if (!button) return;
    event.preventDefault();
    run(button);
  });
})();
